import { useEffect, useState } from "react";
import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "../layouts/dashboard";
import AuthLayout from "../layouts/auth";
import RegisterPage from "../pages/auth/Register"
import VerifyPage from "../pages/auth/verify"
import LoginPage from "../pages/auth/Login"
import ResetPasswordPage from "../pages/auth/ResetPassword"
import NewPasswordPage from "../pages/auth/NewPassword"
import GeneralApp from "../pages/dashboard/GeneralApp"
import ChatPage from "../pages/dashboard/ChatPage"
import CallPage from "../pages/dashboard/CallPage"
import VideoCallPage from "../pages/dashboard/VideoCallPage"
import ItinearyPage from "../pages/dashboard/ItinearyPage"
import SettingPage from "../pages/dashboard/SettingPage"
import TranslatePage from "../pages/dashboard/TranslatePage"
import ChatSettingPage from "../pages/dashboard/ChatSettingPage.js"
import CallSettingPage from "../pages/dashboard/CallSettingPage.js"
import PremiumPage from "../pages/dashboard/PremiumPage"
import AboutusPage from "../pages/dashboard/AboutusPage"
import HelpPage from "../pages/dashboard/ContactPage.js"
import PrivacyPolicyPage from "../pages/dashboard/PrivacyPolicyPage.js"
import PrivacyPage from "../pages/dashboard/PrivacyPage.js";
import TermsAndConditionPage from "../pages/dashboard/Terms&ConditionPage.js"
import Page404 from "../pages/Page404"
// config
import { DEFAULT_PATH } from "../config";
//import LoadingScreen from "../components/LoadingScreen";
import ReloadingScreen from "../components/RobotLoading/Reloading";

/* const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
}; */

const LoadingWrapper = ({ Component }) => {
  const [loading, setLoading] = useState(!localStorage.getItem('hasLoaded'));

  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => {
        setLoading(false);
        localStorage.setItem('hasLoaded', 'true');
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [loading]);

  return loading ? <ReloadingScreen /> : <Component />;
};


export default function Router() {
  return useRoutes([
    {
      path: "/auth",
      element: <AuthLayout />,
      children: [
        { path: "login", element: <LoginPage /> },
        { path: "register", element: <RegisterPage /> },
        { path: "reset-password", element: <ResetPasswordPage /> },
        { path: "new-password", element: <NewPasswordPage /> },
        { path: "verify", element: <VerifyPage /> },
        {path:"privacyPolicy",element:<PrivacyPage/>},
        {path:"termsandCondition",element:<TermsAndConditionPage/>},
      ],
    },
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to={DEFAULT_PATH} replace />, index: true },
        {
          path: "app", element: localStorage.getItem('hasLoaded') ? (
            <GeneralApp />
          ) : (
            <LoadingWrapper Component={GeneralApp} />
          ),
        },
        { path: "premium", element: <PremiumPage /> },
        {path: "aboutus", element: <AboutusPage />},
        { path: "help", element: <HelpPage /> },
        { path: "privacypolicy", element: <PrivacyPolicyPage /> },
        { path: "itinerary", element: <ItinearyPage /> },
        { path: "translate", element: <TranslatePage /> },
        { path: "setting", element: <SettingPage /> },
        { path: "chatSetting", element: <ChatSettingPage /> },
        { path: "callSetting", element: <CallSettingPage /> },
        { path: "chat", element: <ChatPage /> },
        { path: "call", element: <CallPage /> },
        { path: "videoCall", element: <VideoCallPage /> },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}

/* const GeneralApp = Loadable(lazy(() => import("../pages/dashboard/GeneralApp")));
const ChatPage = Loadable(lazy(() => import("../pages/dashboard/ChatPage")));
const PremiumPage = Loadable(
  lazy(() => import("../pages/dashboard/PremiumPage"))
);
const HelpPage = Loadable(
  lazy(() => import("../pages/dashboard/ContactPage.js"))
);
const PrivacyPolicyPage = Loadable(lazy(()=> import("../pages/dashboard/PrivacyPolicyPage.js")))
const TranslatePage = Loadable(
  lazy(() => import("../pages/dashboard/TranslatePage"))
);
const ItinearyPage = Loadable(
  lazy(() => import("../pages/dashboard/ItinearyPage"))
);
const SettingPage = Loadable(
  lazy(() => import("../pages/dashboard/SettingPage"))
);
const ChatSettingPage = Loadable(lazy(()=> import("../pages/dashboard/ChatSettingPage.js")))
const CallPage = Loadable(lazy(() => import("../pages/dashboard/CallPage")));
const VideoCallPage = Loadable(
  lazy(() => import("../pages/dashboard/VideoCallPage"))
);
const LoginPage = Loadable(lazy(() => import("../pages/auth/Login")));
const VerifyPage = Loadable(lazy(() => import("../pages/auth/verify")));
const RegisterPage = Loadable(lazy(() => import("../pages/auth/Register")));
const ResetPasswordPage = Loadable(
  lazy(() => import("../pages/auth/ResetPassword"))
);
const NewPasswordPage = Loadable(
  lazy(() => import("../pages/auth/NewPassword"))
);
const Page404 = Loadable(lazy(() => import("../pages/Page404"))); */
